import libEnv from '@lib/env';

const noop = (v: string | undefined) => v;

export default function env(name: string, defaultValue?: unknown, formatter: (value: string | undefined) => any = noop) {
  return libEnv(formatter(import.meta.env[`VITE_${name}`]), defaultValue);
}
